import React, {createContext, useCallback, useContext, useMemo, useState} from "react";
import {
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Text,
    useBreakpointValue,
    useDisclosure,
} from "@chakra-ui/react";
import QuoteForm from "./QuoteForm";

const QuoteContext = createContext({openQuote: () => {}});

// Lets any button on the site open the quote form, optionally pre-selecting a product.
export function QuoteProvider({children}) {
    const {isOpen, onOpen, onClose} = useDisclosure();
    const [product, setProduct] = useState("");
    const size = useBreakpointValue({base: "full", md: "2xl"});

    const openQuote = useCallback((productTitle = "") => {
        setProduct(productTitle);
        onOpen();
    }, [onOpen]);

    const value = useMemo(() => ({openQuote}), [openQuote]);

    return (
        <QuoteContext.Provider value={value}>
            {children}
            <Modal isOpen={isOpen} onClose={onClose} size={size} scrollBehavior="inside">
                <ModalOverlay/>
                <ModalContent borderRadius={{base: 0, md: "4px"}} borderTop="4px solid" borderColor="brand.500">
                    <ModalHeader pt={7}>
                        <Text as="span" display="block" fontFamily="heading" textTransform="uppercase" fontSize="2xl" letterSpacing="0.03em">
                            Book a free estimate & quote
                        </Text>
                        <Text as="span" display="block" fontSize="sm" fontWeight={400} color="ink.500" mt={1}>
                            Leave your details and we will get back to you.
                        </Text>
                    </ModalHeader>
                    <ModalCloseButton top={5}/>
                    <ModalBody pb={8}>
                        <QuoteForm defaultProduct={product} onSent={onClose}/>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </QuoteContext.Provider>
    );
}

export const useQuote = () => useContext(QuoteContext);
